import { atom } from "jotai"

type AuthSheetState = {
  open: boolean
  /** Where to navigate after a successful login (omit to stay on the page) */
  redirectTo?: string
}

/** Drives the global login bottom sheet (see components/modals/AuthSheet). */
const authSheetAtom = atom<AuthSheetState>({ open: false })

export default authSheetAtom
